export default {
  basicLogoInfo: (state) => state.basicLogoInfo,
  // 获取LOGO列表
  logoList: (state) => JSON.parse(JSON.stringify(state.logoList)),
  // 获取LOGO返回的总数
  logoTotalCount: (state) => state.logoTotalCount,
  // 预览LOGO图片列表
  imgList: (state) => state.imgList,
  ossInfo: (state) => state.ossInfo,
  uploadState: (state) => state.uploadState,
  ossUrl: (state) => state.ossUrl,
  saveState: (state) => state.saveState,
  logoInfo: (state) => JSON.parse(JSON.stringify(state.logoInfo)),
  handleFreezeState: (state) => state.handleFreezeState
}



// WEBPACK FOOTER //
// ./src/store/logo/getters.js